import { useState, useEffect } from "react";
import { getCurrentSessionProject } from "../services/currentProject";

export function useCurrentProject() {
  const [currentProjectPath, setCurrentProjectPath] = useState<string | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);
  const [refreshCounter, setRefreshCounter] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    const path = getCurrentSessionProject();
    setCurrentProjectPath(path);
    setIsLoading(false);
  }, [refreshCounter]);

  const refreshCurrentProject = () => {
    setRefreshCounter((prev) => {
      return prev + 1;
    });
  };

  return {
    currentProjectPath,
    hasProject: !!currentProjectPath,
    isLoading,
    refreshCurrentProject,
  };
}
